import { render, staticRenderFns } from "./StatusValue.vue?vue&type=template&id=c138750e&lang=pug&"
import script from "./StatusValue.vue?vue&type=script&lang=js&"
export * from "./StatusValue.vue?vue&type=script&lang=js&"
import style0 from "./StatusValue.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports